export type { IModalProps } from './Modal'
export { Modal } from './Modal'
